import { useState } from 'react';
import { CSSTransition } from 'react-transition-group';

export default function ActionsEllipsis({ children }) {
  const [showActions, setShowActions] = useState(false);

  return (
    <div className="actions_ellipsis" onMouseLeave={() => setShowActions(false)}>
      <span
        className="ticon-three-dots actions_ellipsis__icon"
        onMouseEnter={() => setShowActions(true)}
      />
      <CSSTransition
        in={showActions}
        classNames="actions_ellipsis__actions"
        timeout={300}
        unmountOnExit={true}
      >
        <div className="actions_ellipsis__actions">{children}</div>
      </CSSTransition>
    </div>
  );
}
